export default "/50f517735fec46580f19aae3e56e9fe21614ea75/b3dc542ec1b5794376b3d1da54a4e35b.svg";